<template>
  <div class="basic_wrap">
    <van-row class="topLogoItem">
      <van-col span="24" class="logoLang">
        <img src="../images/common/logo.png" style="width: 130px" />

        <p class="languageList" @click="$router.push('/language')">
          <span style="padding: 0px 4px" class="ActiveLanguage">EN</span>/<span
            style="padding: 0px 4px"
            >CN</span
          >
        </p>
      </van-col>
    </van-row>
    <form class="form">
      <div>
        <van-row>
          <van-col span="24">
            <div class="loginTopic">
              <p class="loginTopicP">{{ $t("login.login") }}</p>
            </div>
          </van-col>
        </van-row>
        <van-row
          style="margin: 30px 20px 15px; border-bottom: 1px solid #ffffffa3"
        >
          <van-col span="12" style="text-align: center">
            <div
              class="optionTab"
              @click="showInput('username')"
              v-bind:class="this.phoneInput == true ? 'activeTab' : ''"
            >
              <p>{{ $t("login.mobile") }}</p>
              <img
                src="../images/login/activeArrow.png"
                v-show="phoneInput"
                style="height: 12px"
              />
            </div>
          </van-col>
          <van-col span="12" style="text-align: center">
            <div
              class="optionTab"
              @click="showInput('email')"
              v-bind:class="this.emailInput == true ? 'activeTab' : ''"
            >
              <p>{{ $t("login.phoneNumber") }}</p>
              <img
                src="../images/login/activeArrow.png"
                v-show="emailInput"
                style="height: 12px"
              />
            </div>
          </van-col>
        </van-row>
        <!-- <van-row style="margin-top: 30px">
          <van-col span="24"
            ><p class="labelText">{{ $t("login.phoneNumber") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon">
            <img src="../images/login/tel.png" alt="" />
          </span>
          <input type="text" class="inp" v-model.trim="data.username" />
        </div> -->
        <!-- --------------------- show phone number ---------- -->
        <van-row v-show="phoneInput">
          <van-row style="margin-top: 30px">
            <van-col span="24"
              ><p class="labelText">{{ $t("login.mobile") }}:</p></van-col
            >
          </van-row>
          <div class="item">
            <div
              class="icon"
              @click="showCountryPicker = true"
              style="border-right: 1px solid #969799"
            >
              <img :src="countryFlagUrl"     style="height: 18px; width: auto; margin-right: 5px"/>
              <span :v-model="countryCode" style="white-space: nowrap">{{
                countryCode
              }}</span>
            </div>
            <input type="text" class="inp" v-model.trim="data.username" />
          </div>
        </van-row>

        <!-- --------------------- show email ---------- -->

        <van-row v-show="emailInput">
          <van-row style="margin-top: 30px">
            <van-col span="24"
              ><p class="labelText">{{ $t("login.phoneNumber") }}:</p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon">
              <img src="../images/login/email.png" alt="" />
            </span>
            <input type="text" class="inp" v-model.trim="data.username" />
          </div>
        </van-row>

        <!-- ---------- password------------ -->

        <van-row style="margin-top: 20px">
          <van-col span="24"
            ><p class="labelText">{{ $t("login.password") }}:</p></van-col
          >
        </van-row>
        <div class="item">
          <span class="icon"
            ><img src="../images/login/lock.png" alt=""
          /></span>
          <input :type="password" class="inp" v-model.trim="data.password" />
          <div
            class="eye_bi"
            @click="showPwd"
            :class="password == 'text' ? 'eye' : ''"
          ></div>
        </div>
        <van-row style="margin: 5px 18px">
          <van-col span="24">
            <p>
              <router-link class="reset_pwd" to="/forgetpwd">{{
                $t("login.forget")
              }}</router-link>
            </p>
          </van-col>
        </van-row>
        <!-- <div class="item_reset_pwd">
          <van-checkbox v-model="checked" icon-size="14px">{{
            $t("login.remember")
          }}</van-checkbox>
        </div> -->
        <van-row>
          <van-col
            span="24"
            style="display: flex; align-items: center; justify-content: center"
          >
            <div
              type="submit"
              class="login_btn"
              :class="
                data.username == '' || data.password == '' ? 'no_touch' : ''
              "
              @click="submit"
            >
              {{ $t("login.signInBtn") }}
            </div>
          </van-col>
        </van-row>
      </div>

      <van-divider
        :style="{ borderColor: '#ffffff', padding: '30px 20px 0px' }"
      >
      </van-divider>
      <van-row style="padding-top: 20px">
        <van-col span="24" style="text-align: center">
          <p style="font-size: 13px; color: #ffffff">
            {{ $t("login.noAccount") }}
            <router-link to="/register"
              ><span style="color: #f3da2f">{{
                $t("login.createAccount")
              }}</span></router-link
            >
          </p>
        </van-col>
      </van-row>
    </form>
    <van-popup v-model="showCountryPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="countryCodeList"
        @confirm="onConfirm"
        @cancel="showCountryPicker = false"
        :confirm-button-text="$t('bottomSheet.confirmPopup')"
        :cancel-button-text="$t('bottomSheet.cancelPopup')"
      />
    </van-popup>
    <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="../images/index/kefu.png" />
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Popup, Picker, Checkbox, Col, Row, Divider } from "vant";
Vue.use(Popup).use(Picker).use(Checkbox).use(Row).use(Col).use(Divider);

export default {
  name: "login",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      password: "password",
      show_kefu: false,
      msg_show: true,
      checked: true,
      data: {
        username: "",
        password: "",
      },
      phoneInput: true,
      emailInput: false,
      showCountryPicker: false,
      countryCode: "",
      countryCodeList: [],
      countryCodesResponse: [],
      countryFlagUrl: "",
    };
  },
  created() {
    this.data.username = localStorage.getItem("login_username");
    this.data.password = localStorage.getItem("login_password");
    // this.$parent.footer("user", false);
  },
  mounted() {
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    this.getCountryCodes();
  },
  methods: {
    showInput(action) {
      this.data.username = "";
      this.data.password = "";
      // this.data.email = "";
      switch (action) {
        case "username":
          this.emailInput = false;
          this.phoneInput = true;
          break;
        case "email":
          this.phoneInput = false;
          this.emailInput = true;
          break;
        default:
          break;
      }
    },

    onConfirm(value, index) {
      this.countryFlagUrl = this.countryCodesResponse[index].flag;
      this.countryCode = value;
      this.showCountryPicker = false;
    },

    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    submit() {
      if (!this.data.username) {
        this.$toast(this.$t("login.phoneEmpty"));
        return;
      }

      if (!this.data.password) {
        this.$toast(this.$t("login.passwordEmpty"));
        return;
      }

      // var regex = /^[A-Za-z0-9]{1,20}$/;
      // if (!regex.test(this.data.username)) {
      //     this.$toast(this.$t('login.phoneError'));
      //     return;
      // }

      if (this.checked) {
        localStorage.setItem("login_username", this.data.username);
        localStorage.setItem("login_password", this.data.password);
      }

      if (!this.checked) {
        localStorage.removeItem("login_username");
        localStorage.removeItem("login_password");
      }

      Fetch("/user/login", {
        username: this.phoneInput
          ? this.countryCode + this.data.username
          : this.data.username,
        password: this.data.password,
      })
        .then((res) => {
          if (res.data.token) {
            localStorage.setItem("token", res.data.token);
          }
          this.$toast({
            background: "#07c160",
            message: this.$t("login.signInSuccess"),
          });
        })
        .then(() => {
          this.$router.replace({
            path: this.$router.history.current.query.redirect || "/index",
          });
        });
    },
    getCountryCodes() {
      Fetch("/Phone/phonenum_country").then((r) => {
        this.countryCodesResponse = r.data;
        if (this.countryCodesResponse.length > 0) {
          this.countryFlagUrl = this.countryCodesResponse[0].flag;
          this.countryCode = this.countryCodesResponse[0].phone_code;
          r.data.forEach((item) => {
            this.countryCodeList.push(item.phone_code);
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.basic_wrap {
  background: url(../images/startpage/splashBg.png);
  background-size: 100% 100%;
  min-height: 100vh;
}

.topLogoItem {
  align-items: center;
  display: flex;
  padding: 20px;
  padding-top: 50px;
  position: relative;
}

.language img {
  height: 36px;
}

.form {
  padding: 20px;
  margin-top: 100px;
}

.cut_login {
  width: 207px;
  line-height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;

  a {
    width: 50%;
    padding-bottom: 10px;
    color: #ceced0;
    position: relative;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  a.cur {
    color: #f12211;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #f12211, #f18a11);
    }
  }
}

.mt {
  margin-top: 20px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.item_reset_pwd {
  font-size: 14px;
  color: #3d96ff;
  text-align: right;
  margin-top: 10px;
  line-height: 20px;
}
.van-checkbox {
  margin-top: 20px;
}
.reset_pwd {
  color: #f3da2f;
  font-size: 13px;
  display: block;
}

.login_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  background: unset;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 40px;
}

// ======== new design ======
.loginTopic {
  text-align: center;
}

.loginTopicP {
  font-size: 32px;
  padding: 8px;
  color: #ffffff;
  font-weight: 700;
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.eye_bi {
  margin-right: 10px !important;
}

.optionTab {
  padding: 8px 5px 0px;
  color: #ffffff;
  font-size: 20px;
}

.activeTab {
  color: #fff;
  font-weight: 700;
}

.languageList {
  color: #ffffff;
  font-size: 15px;
  border: 1px solid #ffffff;
  padding: 5px 2px;
  border-radius: 5px;
  width: 75px;
  right: 12px;
  position: absolute;
  text-align: center;
}

.logoLang {
  align-items: center;
  display: flex;
}

.ActiveLanguage {
  color: #f3da2f;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  transition: background-color 600000s 0s, color 600000s 0s;
}
</style>
